module.exports = __webpack_public_path__ + "static/media/5.หนังสือยินยอมคู่สมรส (ผู้ค้ำประกัน).14e9e3ef.pdf";